export default function Packaging() {
  const sizes = [
    { size: '250g', type: 'Pouch' },
    { size: '500g', type: 'Pouch' },
    { size: '1 kg', type: 'Pouch' },
    { size: '25 kg', type: 'Bulk Bag' },
    { size: '50 kg', type: 'Bulk Bag' }
  ];

  const features = [
    { icon: 'ri-shield-check-line', text: 'Food grade inner pouch' },
    { icon: 'ri-drop-line', text: 'Moisture resistant packing' },
    { icon: 'ri-lock-line', text: 'Leak proof sealing' },
    { icon: 'ri-filter-line', text: 'Fine powder protection' },
    { icon: 'ri-archive-line', text: 'Easy storage and handling' },
    { icon: 'ri-barcode-line', text: 'Batch and MRP labeling' }
  ];

  return (
    <section id="packaging" className="py-20 bg-gradient-to-b from-white to-green-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            MOQ & Packaging
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* MOQ */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-shopping-cart-line text-orange-500 mr-3"></i>
              Minimum Order Quantity
            </h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-green-50 rounded-lg">
                <span className="text-base font-semibold text-gray-700">Bulk Buyers Minimum Order:</span>
                <span className="text-xl font-bold text-green-600">25 kg</span>
              </div>
              <div className="flex items-center justify-between p-4 bg-orange-50 rounded-lg">
                <span className="text-base font-semibold text-gray-700">Best Wholesale Quantity:</span>
                <span className="text-xl font-bold text-orange-600">50 kg</span>
              </div>
            </div>
          </div>

          {/* Packaging Details */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-box-3-line text-orange-500 mr-3"></i>
              Packaging Details
            </h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-500 mr-3 mt-1"></i>
                <div>
                  <span className="font-semibold text-gray-700">Brand:</span>
                  <span className="text-gray-600 ml-2">Pavitra Rishta</span>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-500 mr-3 mt-1"></i>
                <div>
                  <span className="font-semibold text-gray-700">Packaging Type:</span>
                  <span className="text-gray-600 ml-2">Moisture Proof Sealed Pouch</span>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-500 mr-3 mt-1"></i>
                <div>
                  <span className="font-semibold text-gray-700">Packing:</span>
                  <span className="text-gray-600 ml-2">Hygienically Machine Packed</span>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-500 mr-3 mt-1"></i>
                <div>
                  <span className="font-semibold text-gray-700">Outer Packaging:</span>
                  <span className="text-gray-600 ml-2">Corrugated Box</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Available Sizes */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Available Sizes</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {sizes.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all transform hover:-translate-y-2 text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-box-3-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-1">{item.size}</h4>
                <p className="text-sm text-gray-600">{item.type}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Packaging Features */}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Packaging Features</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all flex items-center space-x-4"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${feature.icon} text-xl text-white`}></i>
                </div>
                <p className="text-base font-semibold text-gray-700">{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}